import { CheckCircle2, AlertTriangle } from "lucide-react";
import Reveal from "@/components/Reveal";

const CONTRACTOR_SIDE = ["Lump-sum quantities, no derivation", "Extras added without basis", "Rates vary between bills", "No measurement record attached"];
const REVIEW_SIDE = ["Quantities re-measured item by item", "Extra items itemised with basis", "Rates checked against agreed BOQ", "Observations documented in writing"];

export default function ComparisonVisual() {
    return (
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2" data-testid="comparison-visual">
            <Reveal className="h-full">
                <div className="h-full border border-slate-200 bg-slate-100 p-8">
                    <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-slate-500">Before</p>
                    <h3 className="mt-2 font-display text-xl font-bold text-slate-500">Contractor Submission</h3>
                    <ul className="mt-6 space-y-4">
                        {CONTRACTOR_SIDE.map((item) => (
                            <li key={item} className="flex items-start gap-3 text-sm text-slate-500">
                                <AlertTriangle size={15} className="mt-0.5 shrink-0 text-slate-400" />
                                <span className="blur-[0.6px]">{item}</span>
                            </li>
                        ))}
                    </ul>
                    <div className="mt-8 space-y-2" aria-hidden="true">
                        <div className="h-2 w-3/4 bg-slate-300" />
                        <div className="h-2 w-1/2 bg-slate-300" />
                        <div className="h-2 w-2/3 bg-slate-300" />
                    </div>
                </div>
            </Reveal>
            <Reveal delay={0.12} className="h-full">
                <div className="tick-frame h-full border border-navy bg-navy p-8">
                    <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-amber">After</p>
                    <h3 className="mt-2 font-display text-xl font-bold text-white">Independent Review</h3>
                    <ul className="mt-6 space-y-4">
                        {REVIEW_SIDE.map((item) => (
                            <li key={item} className="flex items-start gap-3 text-sm text-slate-200">
                                <CheckCircle2 size={15} className="mt-0.5 shrink-0 text-amber" />
                                {item}
                            </li>
                        ))}
                    </ul>
                    <div className="mt-8 border-t border-slate-700 pt-4">
                        <p className="font-mono text-[11px] uppercase tracking-[0.15em] text-slate-400">
                            Documented observations — shared before you pay
                        </p>
                    </div>
                </div>
            </Reveal>
            <p className="text-xs leading-relaxed text-slate-500 md:col-span-2">
                Review findings are documented technical observations based on the records and site conditions made
                available. They support your payment decisions — they are not a guarantee of savings.
            </p>
        </div>
    );
}
